<div class="container">
    <iframe allowfullscreen="" class="Iframe-iframe-ad8182" frameborder="0" id="55cc5f05-2e57-4ad4-9033-323f530b8f16"
        src="https://app.termly.io/embed/terms-of-use/55cc5f05-2e57-4ad4-9033-323f530b8f16" title="Termly Policy"
        style="opacity: 1; width: 100%; min-height: 90vh;">
        <p>Your browser does not support iframes.</p>
    </iframe>
</div>